import { ASChartDonut, ASChartDonutProps, ComponentSize, extendASTheme, useASTheme } from '@eleventheye/asui';
import { getTeamColorsByTeamId } from 'helpers/TeamHelpers';
import React from 'react';

type TeamDonutChartProps = {
  teamId: number;
  isLeaderChart?: boolean;
} & ASChartDonutProps;

const TeamDonutChart: React.FC<TeamDonutChartProps> = ({ teamId, isLeaderChart = false, theme, ...props }) => {
  const inheritedTheme = useASTheme(theme);
  const teamColors = getTeamColorsByTeamId(teamId);

  const labelFontSize = isLeaderChart ? '2rem' : '3rem';
  const teamTheme = extendASTheme(inheritedTheme, {
    components: {
      chartdonut: {
        sizes: {
          [ComponentSize.Small]: { labelFontSize },
          [ComponentSize.Medium]: { labelFontSize },
          [ComponentSize.Large]: { labelFontSize },
        },
      },
    },
  });

  return <ASChartDonut {...props} theme={teamTheme} primaryColor={teamColors.primary} />;
};

export default TeamDonutChart;
